import useTranslations from "@/shared/lang/useTranslations";
import { cn } from "@/shared/lib/utils";

import type { WalletMovementsFilterKind } from "../types/wallet-movements-filters.types";

type WalletMovementsFiltersProps = {
  value: WalletMovementsFilterKind;
  onChange: (value: WalletMovementsFilterKind) => void;
};

export const WalletMovementsFilters = ({ value, onChange }: WalletMovementsFiltersProps) => {
  const { t } = useTranslations("cards");

  const options: { id: WalletMovementsFilterKind; label: string }[] = [
    { id: "all", label: t("wallet_movements_filter_all") },
    { id: "TOPUP", label: t("wallet_movements_filter_topup") },
    { id: "TRANSFER", label: t("wallet_movements_filter_transfer") },
    { id: "WITHDRAWAL", label: t("wallet_movements_filter_withdrawal") },
    { id: "FEE", label: t("wallet_movements_filter_fee") },
  ];

  return (
    <div className="inline-flex items-center gap-1 rounded-md bg-muted p-1">
      {options.map((option) => {
        const active = option.id === value;
        return (
          <button
            key={option.id}
            type="button"
            onClick={() => onChange(option.id)}
            className={cn(
              "rounded-sm px-3 py-1.5 text-xs font-medium transition-all",
              active
                ? "bg-background text-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};
